import Routers from './routers/routers';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Globals } from './global/Globals';
import './util/common.css';
import { ClusterProvider } from './pages/ClusterContext/ClusterContext';
import Sessionpopup from './components/SessionTimeout/Sessionpopup';
import { UnauthorizedProvider, useUnauthorized } from './context/Unauthorisedcontext';
import { RoleProvider } from './context/Rolecontext';
import { useRef, useEffect } from 'react';
import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
import { refreshAccessToken } from './services/refreshToken';
import { LanguageContext, LanguageProvider } from './context/Languagecontext';

const ACTIVE_REFRESH_INTERVAL = 55 * 10 * 1000; // 55 minutes

const AppContent = () => {
  const refreshCalled = useRef(false);
  const showPopupTimeout = useRef(null);
  const activeRefreshTimer = useRef(null);
  const { setIsUnauthorized } = useUnauthorized();

  const excludedPaths = [
    "/",
    "/producer-registration",
    "/company-registration",
    "/reset-password",
    "/activate-account",
    "/register",
    "/videotutorials"
  ];

  const onIdle = () => {
    // Start another timer for 20 more seconds to show the session timeout popup
    stopActiveRefreshInterval();
    showPopupTimeout.current = setTimeout(() => {
      if (!excludedPaths.includes(window.location.pathname)) {
      triggerSessionPopup();
      }
    },60 * 60 * 1000); // 30s total idle → show popup
  };

  const onActive = () => {
    // User came back → clear pending popup and reset refresh call flag
    if (showPopupTimeout.current) {
      if (!excludedPaths.includes(window.location.pathname)) {
      refreshAccessToken(null, () => {
      }).catch(() => {
        triggerSessionPopup();
      });
    }
      
      startActiveRefreshTimer();
      clearTimeout(showPopupTimeout.current);
      showPopupTimeout.current = null;
    }
    refreshCalled.current = false;
  };

  const startActiveRefreshTimer = () => {
    if (activeRefreshTimer.current) return; 
    if (!excludedPaths.includes(window.location.pathname)) {
      activeRefreshTimer.current = setInterval(() => {
      refreshAccessToken(null, () => {
      }).catch(() => {
        if (!excludedPaths.includes(window.location.pathname)) {
          triggerSessionPopup();
        }
      }); // Restart timer for next 55 min cycle
      startActiveRefreshTimer();
    }, ACTIVE_REFRESH_INTERVAL);
  }
  };

  const stopActiveRefreshInterval = () => {
    if (activeRefreshTimer.current) {
      clearInterval(activeRefreshTimer.current);
      activeRefreshTimer.current = null;
    }
  };

   const triggerSessionPopup = () => {
    setIsUnauthorized(true);
    refreshCalled.current = false;
  };


  useEffect(() => {
    // Start 55 min timer when component mounts
    startActiveRefreshTimer();
    return () => {
      stopActiveRefreshInterval();
      if (showPopupTimeout.current) {
        clearTimeout(showPopupTimeout.current);
      }
    };
  }, []);

  return (
    <IdleTimerProvider
      timeout={30 * 1000} // start detecting idle after 10s
      onIdle={onIdle}
      onActive={onActive}
      debounce={500} // prevent rapid triggering
      events={['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll']}
    >
      
      <Routers />
      <Sessionpopup />
     
    </IdleTimerProvider>
  );
};

export default function App() {
  return (
    <ClusterProvider>
      <RoleProvider>
      <LanguageProvider>
        <UnauthorizedProvider>
          <AppContent />
        </UnauthorizedProvider>
        </LanguageProvider>
      </RoleProvider>
    </ClusterProvider>
  );
}
